module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "orderReprintModal",
      "title": "Order a Reprint:",
      "size": "lg",
      "hide-footer": true
    }
  }, [_c('section', [_c('p', [_vm._v("Dear Authors and Readers,")]), _vm._v(" "), _c('p', [_vm._v("We offer on demand printing for " + _vm._s(_vm.siteName) + " Journal and Individual Articles. Our options range from a single\n      copy of a black and white article with no cover all the way up to full-color copies of complete issues.")]), _vm._v(" "), _c('p', [_vm._v("Please provide the following information and we will prepare a purchase order for your review.")])]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Paper / Issue Requested:"
    }
  }, [(_vm.reprintItem.cover_url) ? _c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": _vm.reprintItem ? _vm.reprintItem.cover_url : ''
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Issue: Volume " + _vm._s(_vm.reprintItem.volume) + ", Number " + _vm._s(_vm.reprintItem.issue) + " - " + _vm._s(_vm.timestamp) + " Pages: " + _vm._s(_vm.reprintItem.page_start) + " - " + _vm._s(_vm.reprintItem.page_end))]), _vm._v(" "), _c('div', [_vm._v("About the Cover")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.reprintItem.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.reprintItem.caption)
    }
  }), _vm._v(" "), (_vm.reprintItem.articles) ? _c('div', [_vm._v(_vm._s(_vm.reprintItem.articles.length) + " Papers inlcuding: " + _vm._s(_vm.reprintItem.articlesTypes) + ".\n    ")]) : _vm._e()]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Request Preferences:"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Specifications for your Request:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Tell us about any specific requests for this Reprint",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.specifications),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "specifications", $$v)
      },
      expression: "requestData.specifications"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.includeSupplementaryMaterial
    },
    attrs: {
      "label": "Include Supplementary material?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "type": "text",
      "options": ['Yes', 'No']
    },
    model: {
      value: (_vm.requestData.includeSupplementaryMaterial),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "includeSupplementaryMaterial", $$v)
      },
      expression: "requestData.includeSupplementaryMaterial"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.colorScheme
    },
    attrs: {
      "label": "Print in Color or Black & White?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "type": "text",
      "options": ['Color', 'Black & White']
    },
    model: {
      value: (_vm.requestData.colorScheme),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "colorScheme", $$v)
      },
      expression: "requestData.colorScheme"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.includeCover
    },
    attrs: {
      "label": "Include Cover?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "type": "text",
      "options": ['Yes', 'No']
    },
    model: {
      value: (_vm.requestData.includeCover),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "includeCover", $$v)
      },
      expression: "requestData.includeCover"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Shipping Details:"
    }
  }, [_c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.name
    },
    attrs: {
      "label": "Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Full  Name",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.name),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "name", $$v)
      },
      expression: "requestData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.email
    },
    attrs: {
      "label": "Email Address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Email Address",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.email),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "email", $$v)
      },
      expression: "requestData.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.phone
    },
    attrs: {
      "label": "Phone Namber"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Phone Number",
      "formatter": _vm.phoneFormater
    },
    model: {
      value: (_vm.requestData.phone),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "phone", $$v)
      },
      expression: "requestData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.instruction
    },
    attrs: {
      "label": "Institution"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Your Affiliated Institution",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.instruction),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "instruction", $$v)
      },
      expression: "requestData.instruction"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devider"
  }), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      error: _vm.attemptSubmit && !_vm.validation.address
    },
    attrs: {
      "label": "Shipping Address, including Zip Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Your Shipping Address",
      "type": "text"
    },
    model: {
      value: (_vm.requestData.address),
      callback: function($$v) {
        _vm.$set(_vm.requestData, "address", $$v)
      },
      expression: "requestData.address"
    }
  })], 1), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.request()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), (_vm.attemptSubmit && !_vm.isValid) ? _c('div', [_vm._v("Error")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c32d281"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/OrderReprintComponent.vue
// module id = 1444
// module chunks = 1